import { dealLng } from '@/utils';
import { Image } from '@nextui-org/react';
import Link from 'next/link';

interface IProps {
  bookList: {
    _id: string;
    title: string;
    _urlId: string;
    coverPath: string;
  }[];
  lng: string;
}
export default function MobileBookList(props: IProps) {
  const { bookList } = props;
  return (
    <div className='flex  overflow-auto'>
      <div className="book-detail flex">
        {
          bookList.map(book => {
            return (
              <div className="book-item w-[126px] shrink grow-0 flex flex-col ml-3 first:ml-0" key={book._id}>
                <Link href={`${dealLng(props.lng)}/book/${book._urlId}`}>
                <Image src={book.coverPath} alt={book.title} width={126} height={189} radius='none' className='rounded-r-xl bg-cover h-[189px]' />
                </Link>
                <p className='text-16-22 max-w-[156px] pt-2'>{book.title}</p>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
